"use client";

import React from "react";
import SelectContent from "./select-content";
import SelectItem from "./select-item";
import SelectRoot from "./select-root";
import SelectTrigger from "./select-trigger";
import SelectValue from "./select-value";
import { cn } from "@/lib/utils";

type SelectItem = {
  value: string;
  label: string;
};

export interface SelectProps extends React.ComponentProps<typeof SelectRoot> {
  id?: string;
  className?: string;
  items: SelectItem[];
  label?: string;
  placeholder?: string;
  triggerClassName?: string;
}

const Select: React.FC<SelectProps> = ({
  id,
  className,
  items = [],
  placeholder,
  label,
  required,
  triggerClassName,
  ...props
}) => {
  const labelText = label && `${label}${required ? " *" : ""}`;
  const placeholderText = placeholder || labelText || "Select an option";

  return (
    <div className={cn("group flex w-full flex-col", className)}>
      {label && (
        <label
          htmlFor={id}
          className={"mb-2 font-roboto text-body-1-400 text-neutral-600"}
        >
          {labelText}
        </label>
      )}
      <SelectRoot
        {...props}
        required={required}
      >
        <SelectTrigger
          id={id}
          className={triggerClassName}
        >
          <SelectValue placeholder={placeholderText} />
        </SelectTrigger>
        <SelectContent>
          {items.map((item, index) => (
            <SelectItem
              key={`${id}-${item.value}-${index}`}
              value={item.value}
            >
              {item.label}
            </SelectItem>
          ))}
        </SelectContent>
      </SelectRoot>
    </div>
  );
};

export default Select;
